import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const AnnuaireArtisans = () => {
  const navigate = useNavigate();

  // Fonction pour rediriger vers la page de choix
  const handleChoosePackage = (basePackage) => {
    navigate(`/choix-forfait?base=${basePackage}`);
  };

  return (
    <div>
      <section style={{ padding: "50px 0", backgroundColor: "#f8f9fa" }}>
        <Container>
          <h1 className="text-center" style={{ marginBottom: "30px" }}>
            Rejoignez l'Annuaire Renovestim
          </h1>
          <p
            className="text-center"
            style={{ fontSize: "1.2rem", marginBottom: "30px" }}
          >
            Faites partie de notre réseau d'artisans et recevez des projets
            qualifiés grâce à Renovestim.
          </p>

          {/* Section Catégories */}
          <section style={{ marginBottom: "50px" }}>
            <h2 className="text-center" style={{ marginBottom: "20px" }}>
              Forfaits par catégories par régions
            </h2>
            <p className="text-center" style={{ marginBottom: "30px" }}>
              Choisissez un forfait selon vos besoins. Plus vous ajoutez de
              catégories ou de régions, plus vous augmentez vos chances d'être
              trouvé par nos utilisateurs.
            </p>
            <Row>
              <Col md={4}>
                <Card className="text-center h-100">
                  <Card.Body>
                    <Card.Title>1 Catégorie par région</Card.Title>
                    <Card.Text>
                      <strong>49€ / an</strong>
                      <br />
                      Idéal pour se concentrer sur un seul métier.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => handleChoosePackage(49)}
                    >
                      Choisir
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="text-center h-100">
                  <Card.Body>
                    <Card.Title>3 Catégories par région</Card.Title>
                    <Card.Text>
                      <strong>99€ / an</strong>
                      <br />
                      Optimisé pour les artisans avec plusieurs compétences.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => handleChoosePackage(69)}
                    >
                      Choisir
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="text-center h-100">
                  <Card.Body>
                    <Card.Title>10 Catégories par région</Card.Title>
                    <Card.Text>
                      <strong>299€ / an</strong>
                      <br />
                      Maximisez votre visibilité dans plusieurs corps de métier.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => handleChoosePackage(99)}
                    >
                      Choisir
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>

          {/* Section Boost */}
          <section>
            <h2 className="text-center" style={{ marginBottom: "20px" }}>
              Boostez votre visibilité
            </h2>
            <p className="text-center" style={{ marginBottom: "30px" }}>
              Augmentez votre exposition auprès des utilisateurs de Renovestim
              avec nos options Boost. Soyez mis en avant dans votre région ou
              dans toute la France.
            </p>
            <Row>
              <Col md={6}>
                <Card className="text-center h-100">
                  <Card.Body>
                    <Card.Title>Boost Région</Card.Title>
                    <Card.Text>
                      <strong>99€ / an / catégorie</strong>
                      <br />
                      Soyez priorisé dans votre région.
                    </Card.Text>
                    <Button
                      variant="secondary"
                      onClick={() => handleChoosePackage(99)}
                    >
                      Choisir
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="text-center h-100">
                  <Card.Body>
                    <Card.Title>Boost France</Card.Title>
                    <Card.Text>
                      <strong>299€ / an / catégorie</strong>
                      <br />
                      Soyez mis en avant dans tout le pays.
                    </Card.Text>
                    <Button
                      variant="secondary"
                      onClick={() => handleChoosePackage(299)}
                    >
                      Choisir
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>
        </Container>
      </section>
    </div>
  );
};

export default AnnuaireArtisans;
